import React, { useEffect, useRef, useState } from 'react';

import { Container, Button, Dropdown, DropdownButton, Alert, Col, Row, Spinner, OverlayTrigger, Tooltip, Toast, ToastContainer } from 'react-bootstrap';
import * as sanitizeHtml from 'sanitize-html';
import showdown from "showdown";
import './MdReader.scss';


const MdReader = (props) => {
    const converter = new showdown.Converter()
    converter.setOption('strikethrough', true)

    const html = converter.makeHtml(props.mdData)
    const sanitizedHtml = sanitizeHtml(html, {
        allowedTags: ["h1", "h2", "h3", "h4", "h5", "h6", "div", "hr", "li", "ol", "p", "ul", "b", "br", "em", "i", "s", "strong", "u", "del"]
    });

    return (
        <div id="MdReader" dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
    )

}

export default MdReader;